<template>
  <div class="logout-container">
    <div class="message-box">
      <h1>See you later!</h1>
      <p>Thanks for hanging out with us at RiskyPaws. We hope you had a purr-fect time!</p>
      <img src="https://assets.codepen.io/11151897/catchickens.gif" alt="Cat waving goodbye">
      <p>Want to support our mission in promoting financial literacy? Check out what we’re doing and how you can help!</p>
      <a href="https://www.riskypaws.org" class="cta-button">Learn More & Support</a>
      <button @click="logout" class="cta-button" style="display: block; margin-top: 20px;">Log Out</button>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  methods: {
    async logout() {
      try {
        await Auth.signOut();
        // Redirect to login page or home page after logout
        this.$router.push('/login'); // Update '/login' to the route you wish to redirect to after logout
      } catch (error) {
        console.error('error signing out: ', error);
      }
    }
  }
};
</script>
  <style scoped>
  .logout-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f0f0f0;
  }
  
  .message-box {
    text-align: center;
    padding: 20px;
    background: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%);
    border-radius: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  .message-box h1 {
    color: white;
    font-size: 2rem;
  }
  
  .message-box p {
    color: white;
    margin: 10px 0;
    font-size: 1.2rem;
  }
  
  .message-box img {
    width: 50%;
    max-width: 300px;
    margin-top: 20px;
  }
  
  .cta-button {
    display: inline-block;
    background-color: #4A148C; /* Updated to match the logout button */
    color: white;
    padding: 10px 20px;
    margin-top: 20px;
    border-radius: 5px; /* Updated for consistency */
    text-decoration: none;
    font-weight: bold;
    transition: background-color 0.3s;
  }
  
  .cta-button:hover {
    background-color: #6C1B9A; /* Updated for a lighter purple on hover */
  }
  </style>